export default {
    defaultAvatar: require("image/default/avatar.jpg")
}